import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const PhoneVerificationCodeSchema = yup.object({
  /**
   * Input the phone number verification code sent to the phone
   * This is usually a 4 digit number
   * @example '2234'
   */
  code: yup.string().required(REQUIRED_MESSAGE),
})

export type TPhoneVerificationCodeSchema = yup.InferType<typeof PhoneVerificationCodeSchema>
